import React, { useState } from "react";
import Slider from "react-slick";
import CardDocument from "../../atoms/card-document/cardDocument";
import CardVideo from "../../atoms/card-video/cardVideo";
import "./reviewSlider.scss";

interface DocumentsSliderInterface {
  reviews: any;
  gtmClass: string;
  video?: boolean;
}

const ReviewSlider = (props: DocumentsSliderInterface) => {
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();

  // Funciones para desktop
  const goToNext = () => {
    slider.slickGoTo(sliderIndex + (props.video ? 2 : 3));
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - (props.video ? 2 : 3));
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < props.reviews.length - 1 ? _true : _false;
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const settings = {
    className: "center",
    padding: "20%",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: props.video ? 2 : 3,
    slidesToScroll: props.video ? 2 : 3,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };
  const settingsM = {
    className: "center",
    centerPadding: "10%",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: props.video ? 2 : 3,
          slidesToScroll: props.video ? 1 : 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.05,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleBookMobile = () => {
    const booksAux = Array(0);
    const limit = props.reviews.length >= 5 ? 5 : props.reviews.length;
    for (let i = 0; i < limit; i++) {
      booksAux.push(props.video ? <CardVideo review={props.reviews[i]} key={i} gtmClass={props.gtmClass} /> : <CardDocument review={props.reviews[i]} key={i} gtmClass={props.gtmClass} />);
    }
    return booksAux;
  };

  return (
    <section className="m-review-slider">
      <div className="hide-on-mobile">
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {props.reviews.map((review, idx) => {
            if (props.video) {
              return (
                <div className="review-desktop" key={idx}>
                  <CardVideo review={review} key={idx} gtmClass={props.gtmClass}/>
                </div>
              );
            } else {
              return (
                <div className="review-desktop" key={idx}>
                  <CardDocument review={review} key={idx} gtmClass={props.gtmClass}/>
                </div>
              );
            }
          })}
        </Slider>
        <div
          className="arrow-content arrow-content__left"
          onClick={isActiveBack(goToBack, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveBack(
                  "arrow icon-chevron-left active",
                  "arrow icon-chevron-left"
                )}
              />
            </div>
          </div>
        </div>
        <div
          className="arrow-content arrow-content__right"
          onClick={isActiveNext(goToNext, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveNext(
                  "arrow icon-chevron-right active",
                  "arrow icon-chevron-right"
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="show-on-mobile">
        <Slider {...settingsM}>
          {handleBookMobile().map((books) => books)}
        </Slider>
      </div>
    </section>
  );
};

export default ReviewSlider;
